import { PHRASES_COURSE_ID, courseOfLesson } from '../content/course.js';

/**
 * The screen a finished or abandoned lesson returns to (✕, the finish
 * screen's Continue, the level-up modal): the ფრაზები screen for the phrases
 * course (PHRASES.md § 3), Home for the main course and any lesson outside a
 * course tree. The demo player overrides it with its own route.
 */
export function lessonExitTo(lessonId: string): string {
  return courseOfLesson(lessonId) === PHRASES_COURSE_ID ? '/phrases' : '/';
}
